import React from "react";
import { Container, Content } from "./styles";
import ModalContentHeader from "../ModalContentHeader";

type Props = {
  onClose?: () => void;
};

const ModalContent: React.FC<Props> = ({ children, onClose }) => {
  return (
    <Container>
      <ModalContentHeader onClose={onClose}></ModalContentHeader>
      <Content>{children}</Content>
    </Container>
  );
};

export default ModalContent;
